import type { PersonConfigurationOptionsType as ApiPersonConfigurationOptionsType } from 'src/api/generated/touring/types';
import type { PersonConfigurationOptionsType } from '../../types';

export const mapPersonConfigurationOptionsType = (
  api: ApiPersonConfigurationOptionsType
): PersonConfigurationOptionsType => ({
  kind: api.kind,
  personId: api.personId,
  scope: api.scope,
  includeRevenue: api.includeRevenue,
  recipientMail: api.recipientMail,
});
